import React from "react";
import FormField from "../FormField";

interface TextAreaInputFieldProps {
  id: string;
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  maxLength: number;
}

function TextAreaInputField({
  className,
  disabled,
  id,
  label,
  onChange,
  placeholder,
  value,
  maxLength,
}: TextAreaInputFieldProps) {
  return (
    <FormField htmlFor={id} label={label || ""}>
      <textarea
        id={id}
        value={value}
        onChange={onChange}
        className={`focus:border-soluud-primary focus:ring-soluud-primary/30 block w-full rounded-lg border border-gray-300 py-2 pr-3 pl-3 text-base transition-colors duration-150 focus:ring-2 focus:outline-none sm:text-sm ${className}`}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
      />
    </FormField>
  );
}

export default TextAreaInputField;
